import {ApplicationSource} from "../../application/utils/form/application_form_source";
import {UNLOCK_CHOICE_TRACKING} from "../constants/unlock_choice_tracking";
import {IUnlockChoiceLeadRequest} from "../types/IUnlockChoiceLeadRequest";
import {IUnlockChoiceLeadOption} from "../types/IUnlockChoiceOption";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

// The lead sent by a lead option of the choice, reported from the form location of the entry point
export const getUnlockChoiceOptionLead = (
    entryPoint: UnlockChoiceEntryPoint,
    option: IUnlockChoiceLeadOption,
    source: ApplicationSource
): IUnlockChoiceLeadRequest => ({
    source,
    ctaText: option.ctaText,
    formLocation: UNLOCK_CHOICE_TRACKING[entryPoint].buttonCategory,
    confirmationSubject: option.confirmationSubject
});
import {ApplicationSource} from "../../application/utils/form/application_form_source";
import {UNLOCK_CHOICE_TRACKING} from "../constants/unlock_choice_tracking";
import {IUnlockChoiceLeadRequest} from "../types/IUnlockChoiceLeadRequest";
import {IUnlockChoiceLeadOption} from "../types/IUnlockChoiceOption";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";

// The lead sent by a lead option of the choice, reported from the form location of the entry point
export const getUnlockChoiceOptionLead = (
    entryPoint: UnlockChoiceEntryPoint,
    option: IUnlockChoiceLeadOption,
    source: ApplicationSource
): IUnlockChoiceLeadRequest => ({
    source,
    ctaText: option.ctaText,
    formLocation: UNLOCK_CHOICE_TRACKING[entryPoint].buttonCategory,
    confirmationSubject: option.confirmationSubject
});
